export default class UserInquiryCategory {
    public id: number;
    public typeId: number;
    public descriptions: any;

    constructor(
        id: number,
        typeId: number,
        descriptions: any,
    ) {
        this.id = id;
        this.typeId = typeId;
        this.descriptions = descriptions;
    }

    public title(languageId: number) {
        const localizedDescription = this.descriptions.find((description: any) => description.languageId === languageId);
        return typeof localizedDescription !== 'undefined' ? localizedDescription.description : this.descriptions[0].description;
    }
}
